// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-connection {
  width: 100%;
  min-width: 0;
  color: #14213b;
  font-family: Manrope,"Segoe UI",sans-serif
}
.data-connection__header {
  box-shadow: none
}
.dc-workspace {
  background: #f8fafd;
  border: 1px solid #e5eaf2;
  border-radius: 14px;
  padding: 26px;
  min-height: 420px
}
.dc-workspace *,.dc-modal * {
  box-sizing: border-box
}
.dc-tools {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px
}
.dc-search {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
  min-width: 220px;
  margin: 0;
  background: white;
  border: 1px solid #e5eaf2;
  border-radius: 11px;
  padding: 0 14px;
  color: #68758b
}
.dc-search input {
  margin: 0;
  border: 0;
  outline: 0;
  min-height: 48px;
  min-width: 0;
  width: 100%;
  background: transparent;
  font: inherit;
  font-size: 14px;
  color: #14213b
}
.dc-button,.dc-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  min-height: 44px;
  border: 1px solid #dfe7f2;
  border-radius: 10px;
  background: white;
  color: #334766;
  padding: 10px 15px;
  font: inherit;
  font-size: 13px;
  font-weight: 650;
  cursor: pointer;
  text-decoration: none
}
.dc-tools > .dc-button {
  min-height: 50px;
  margin: 0
}
.dc-button--primary {
  background: #1769e8;
  color: white;
  border-color: #1769e8
}
.dc-button--danger {
  background: #b42332;
  color: white;
  border-color: #b42332
}
.dc-button:hover,.dc-icon:hover {
  filter: brightness(.96)
}
.dc-button:disabled,.dc-icon:disabled {
  opacity: .5;
  cursor: default
}
.dc-icon {
  width: 44px;
  padding: 10px;
  flex-shrink: 0
}
.data-connection button:focus-visible,.dc-modal button:focus-visible,.dc-modal input:focus-visible,.dc-modal select:focus-visible,.dc-modal textarea:focus-visible,.dc-search:focus-within {
  outline: 3px solid #80b1ff;
  outline-offset: 2px
}
.dc-filters {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin: 16px 0
}
.dc-filters select {
  background: white;
  border: 1px solid #e5eaf2;
  border-radius: 9px;
  min-height: 42px;
  padding: 8px 12px;
  font: inherit;
  font-size: 13px;
  color: #334766
}
.dc-filters>span {
  margin-left: auto;
  color: #68758b;
  font-size: 12px
}
.dc-note {
  font-size: 12px;
  line-height: 1.6;
  color: #68758b;
  margin: 8px 0
}
.dc-list {
  display: grid;
  gap: 12px
}
.dc-card {
  display: flex;
  align-items: center;
  border: 1px solid #dce6f5;
  border-radius: 14px;
  background: white;
  min-width: 0;
  padding-right: 12px;
  transition: border-color .15s,background .15s
}
.dc-card:hover {
  border-color: #9ebfee;
  background: #fbfdff
}
.dc-card-main {
  display: flex;
  align-items: center;
  gap: 18px;
  width: 100%;
  min-width: 0;
  text-align: left;
  padding: 20px;
  border: 0;
  background: transparent;
  cursor: pointer;
  font: inherit;
  color: inherit
}
.dc-source-icon {
  display: grid;
  place-items: center;
  width: 50px;
  height: 50px;
  flex-shrink: 0;
  border-radius: 14px;
  background: #eaf2ff;
  color: #1769e8;
  font-size: 22px
}
.dc-source-icon--green {
  background: #e9f8f2;
  color: #159b70
}
.dc-card-copy {
  display: flex;
  flex-direction: column;
  gap: 7px;
  min-width: 0;
  flex: 1 1
}
.dc-card-copy>strong {
  font-size: 16px;
  line-height: 1.4;
  overflow-wrap: anywhere
}
.dc-card-copy>span:not(.dc-badges) {
  font-size: 13px;
  color: #68758b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%
}
.dc-badges {
  display: flex;
  gap: 6px;
  flex-wrap: wrap
}
.dc-badges em {
  background: #eef4ff;
  color: #3674c6;
  border-radius: 20px;
  padding: 4px 9px;
  font-size: 11px;
  font-style: normal
}
.dc-card-meta {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 10px;
  width: 180px;
  flex-shrink: 0
}
.dc-card-meta small {
  font-size: 11px;
  color: #68758b;
  line-height: 1.5
}
.dc-pill {
  background: #e8f7f0;
  color: #168560;
  padding: 5px 11px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600
}
.dc-pill--paused {
  background: #fff4df;
  color: #90621a
}
.dc-delete {
  color: #8a6870;
  border-color: transparent;
  background: transparent
}
.dc-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 48px 20px;
  background: white;
  border: 1px dashed #d8e3f2;
  border-radius: 14px;
  gap: 12px
}
.dc-empty h2 {
  font-size: 21px;
  margin: 8px 0
}
.dc-empty p {
  font-size: 14px;
  line-height: 1.6;
  color: #68758b;
  max-width: 480px
}
.dc-alert {
  background: #eaf7ef;
  border: 1px solid #cbe8d6;
  border-radius: 10px;
  padding: 13px 16px;
  margin: 12px 0;
  font-size: 13px;
  overflow-wrap: anywhere
}
.dc-alert--error {
  background: #fff3f1;
  border-color: #f0d1cc;
  color: #962c22
}
.dc-status {
  display: flex;
  gap: 10px;
  flex-direction: column;
  font-size: 12px;
  color: #68758b;
  margin: 14px 0
}
.dc-status--error {
  color: #a83d2f
}
.dc-status span {
  overflow-wrap: anywhere;
  max-width: 100%
}
.dc-overlay {
  position: fixed;
  inset: 0;
  z-index: 2400;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #16233b66;
  backdrop-filter: blur(3px)
}
.dc-modal {
  background: white;
  border: 1px solid #dfe7f2;
  border-radius: 18px;
  width: min(820px,100%);
  max-height: calc(100dvh - 48px);
  display: flex;
  flex-direction: column;
  box-shadow: 0 24px 80px #14213b33;
  color: #14213b;
  font-family: Manrope,"Segoe UI",sans-serif;
  overflow: hidden
}
.dc-modal>header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 24px;
  border-bottom: 1px solid #e5eaf2;
  flex-shrink: 0;
  gap: 16px
}
.dc-modal h2 {
  font-size: 20px;
  margin: 0;
  font-weight: 750
}
.dc-editor {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden
}
.dc-modal-body {
  padding: 24px;
  overflow-y: auto;
  overscroll-behavior: contain;
  min-height: 0
}
.dc-modal footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid #e5eaf2;
  flex-shrink: 0;
  background: white
}
.dc-modal fieldset {
  border: 1px solid #e5eaf2;
  border-radius: 12px;
  margin: 16px 0;
  padding: 16px;
  min-width: 0
}
.dc-modal legend {
  font-size: 14px;
  font-weight: 750;
  color: #334766;
  padding: 0 6px
}
.dc-modal label {
  display: flex;
  flex-direction: column;
  gap: 7px;
  font-size: 13px;
  color: #334766;
  margin: 10px 0;
  min-width: 0
}
.dc-modal input:not([type=checkbox]),.dc-modal select,.dc-modal textarea {
  width: 100%;
  min-width: 0;
  border: 1px solid #dce5f1;
  border-radius: 9px;
  background: #fbfcff;
  color: #14213b;
  padding: 11px 12px;
  font: inherit;
  font-size: 14px;
  min-height: 44px
}
.dc-modal textarea {
  resize: vertical;
  font-family: ui-monospace,monospace;
  line-height: 1.5
}
.dc-two {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px
}
.dc-types {
  display: flex;
  gap: 10px
}
.dc-types button {
  flex: 1 1;
  min-height: 48px;
  border: 1px solid #e5eaf2;
  background: white;
  color: #68758b;
  border-radius: 11px;
  font: inherit;
  font-size: 14px;
  cursor: pointer
}
.dc-types .selected {
  border-color: #1769e8;
  background: #edf4ff;
  color: #1769e8
}
.dc-check {
  display: flex!important;
  flex-direction: row!important;
  align-items: center;
  gap: 12px!important;
  line-height: 1.6
}
.dc-check input {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  accent-color: #1769e8
}
.dc-preview {
  padding: 12px 0;
  font-size: 13px;
  overflow-wrap: anywhere
}
.dc-preview pre {
  max-height: 280px;
  overflow: auto;
  border: 1px solid #e5eaf2;
  border-radius: 10px;
  background: #f6f9fd;
  padding: 14px;
  font: 12px/1.6 ui-monospace,monospace;
  white-space: pre-wrap;
  overflow-wrap: anywhere
}
.dc-entities {
  max-height: 300px;
  overflow: auto
}
.dc-entities label {
  padding: 8px;
  border-bottom: 1px solid #edf0f5
}
.dc-entities span {
  min-width: 0;
  overflow-wrap: anywhere
}
.dc-entities small {
  display: block;
  color: #68758b;
  font-size: 11px
}
.dc-entities label>span:last-child {
  margin-left: auto
}
.dc-modal input:disabled {
  opacity: .65
}
@media(max-width:760px) {
  .dc-workspace {
    padding: 16px 12px
  }
  .dc-search {
    flex-basis: 100%
  }
  .dc-tools>.dc-button--primary {
    flex: 1 1
  }
  .dc-card-main {
    gap: 12px;
    padding: 16px 12px;
    flex-wrap: wrap
  }
  .dc-card-copy {
    flex-basis: calc(100% - 65px)
  }
  .dc-card-meta {
    width: 100%;
    padding-left: 62px;
    flex-direction: row;
    align-items: center
  }
  .dc-card-main>svg {
    display: none
  }
  .dc-card {
    position: relative;
    padding-right: 0
  }
  .dc-delete {
    position: absolute;
    right: 8px;
    bottom: 10px
  }
  .dc-card-meta small {
    padding-right: 35px
  }
  .dc-overlay {
    padding: 10px
  }
  .dc-modal {
    max-height: calc(100dvh - 20px);
    border-radius: 14px
  }
  .dc-modal>header,.dc-modal footer {
    padding: 13px 16px
  }
  .dc-modal-body {
    padding: 16px
  }
  .dc-modal h2 {
    font-size: 18px
  }
  .dc-modal fieldset {
    padding: 12px
  }
  .dc-two {
    grid-template-columns: 1fr
  }
  .dc-modal footer>.dc-button {
    flex: 1 1;
    padding: 10px 8px
  }
  .dc-filters>span {
    margin-left: 0
  }
  .dc-empty {
    padding: 32px 16px
  }
}
/* Match the catalog's readable content scale; the shared header keeps its size. */
.dc-workspace,.dc-overlay {
  zoom: calc(1 / var(--dataspace-ui-scale,1))
}
@media(max-width:760px) {
  .dc-modal input:not([type=checkbox]),.dc-modal select,.dc-modal textarea {
    font-size: 16px
  }
  .dc-search input {
    font-size: 16px
  }
}

.dc-import-card .dc-card-copy small, .dc-import-target { overflow-wrap: anywhere; }
.dc-import-error { color: #a52b30; }
.dc-import-editor fieldset { min-width: 0; }
.dc-counter-list { display: grid; gap: .75rem; }
.dc-counter { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1.7fr) auto; gap: .65rem; align-items: end; }
.dc-counter > .dc-icon { margin-bottom: .55rem; }
.dc-import-preview { border: 1px solid #dce6f5; background: #f7faff; border-radius: 12px; padding: 1rem; }
.dc-import-preview > .dc-button { max-width: 100%; white-space: normal; text-align: left; }
.dc-import-preview-result { margin-top: 1rem; }
.dc-import-preview-result ul { list-style: none; padding: 0; margin: .75rem 0 0; max-height: 22rem; overflow-y: auto; }
.dc-import-preview-result li { padding: .75rem 0; border-top: 1px solid #dce6f5; overflow-wrap: anywhere; }
.dc-import-preview-result li > span { display: block; color: #61718a; margin-top: .25rem; }
.dc-import-preview-result summary { cursor: pointer; margin-top: .6rem; color: #1766db; }
.dc-import-preview-result pre { white-space: pre-wrap; overflow-wrap: anywhere; background: #fff; border-radius: 8px; padding: .75rem; max-height: 16rem; overflow: auto; }
@media (max-width: 600px) {
  .dc-counter { grid-template-columns: minmax(0, 1fr) auto; }
  .dc-counter > label { grid-column: 1; }
  .dc-counter > .dc-icon { grid-column: 2; grid-row: 1 / 3; align-self: center; }
}
.dc-import-card > .dc-icon { flex-shrink: 0; margin: 0 .75rem; }
.dc-import-card .dc-card-meta { max-width: 18rem; }
@media (max-width: 600px) { .dc-import-card > .dc-icon { margin: 0 .35rem; } }

.dc-choice-intro { margin: 0 0 20px; color: #68758b; line-height: 1.6; }
.dc-connection-choices { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 14px; }
.dc-connection-choice { display: flex; flex-direction: column; align-items: flex-start; gap: 12px; padding: 20px; border: 1px solid #dce6f5; border-radius: 14px; background: #fff; text-align: left; font: inherit; color: #14213b; cursor: pointer; min-width: 0; }
.dc-connection-choice:hover:not(:disabled) { border-color: #80b1ff; background: #f7faff; }
.dc-connection-choice strong { font-size: 16px; }
.dc-connection-choice > span:last-child { font-size: 13px; line-height: 1.6; color: #68758b; overflow-wrap: anywhere; }
.dc-connection-choice:disabled { opacity: .5; cursor: default; }
.dc-setup { display: flex; align-items: center; justify-content: space-between; gap: 20px; border-top: 1px solid #dce6f5; margin-top: 24px; padding-top: 20px; }
.dc-setup h3 { margin: 0 0 8px; font-size: 16px; }
.dc-setup > .dc-button { flex-shrink: 0; }
.dc-import-card .dc-card-copy small { font-size: 12px; line-height: 1.5; color: #68758b; }
@media (max-width: 600px) {
  .dc-connection-choices { grid-template-columns: minmax(0, 1fr); }
  .dc-connection-choice { padding: 16px; }
  .dc-setup { flex-direction: column; align-items: flex-start; }
  .dc-card-meta { flex-wrap: wrap; }
}

.dc-import-card .dc-card-copy .dc-import-error { color: #a52b30; }
`, "",{"version":3,"sources":["webpack://./src/components/DataConnection.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd;AACF;AACA;EACE;AACF;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb;AACF;AACA;EACE;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf;AACF;AACA;EACE,SAAS;EACT,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf;AACF;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;AACF;AACA;EACE,gBAAgB;EAChB;AACF;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ;AACF;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ;AACF;AACA;EACE;AACF;AACA;EACE,WAAW;EACX;AACF;AACA;EACE,WAAW;EACX,aAAa;EACb;AACF;AACA;EACE,0BAA0B;EAC1B;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf;AACF;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf;AACF;AACA;EACE,iBAAiB;EACjB,cAAc;EACd;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd;AACF;AACA;EACE,aAAa;EACb;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB;AACF;AACA;EACE,qBAAqB;EACrB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd;AACF;AACA;EACE,mBAAmB;EACnB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB;AACF;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB;AACF;AACA;EACE,aAAa;EACb,QAAQ;EACR;AACF;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf;AACF;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ;AACF;AACA;EACE,eAAe;EACf,cAAc;EACd;AACF;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf;AACF;AACA;EACE,mBAAmB;EACnB;AACF;AACA;EACE,cAAc;EACd,yBAAyB;EACzB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB;AACF;AACA;EACE,eAAe;EACf;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd;AACF;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf;AACF;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB;AACF;AACA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd;AACF;AACA;EACE;AACF;AACA;EACE,uBAAuB;EACvB;AACF;AACA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,qBAAqB;EACrB;AACF;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,iCAAiC;EACjC,cAAc;EACd,0CAA0C;EAC1C;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd;AACF;AACA;EACE,eAAe;EACf,SAAS;EACT;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb;AACF;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B;AACF;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd;AACF;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,cAAc;EACd;AACF;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf;AACF;AACA;EACE,gBAAgB;EAChB,mCAAmC;EACnC;AACF;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B;AACF;AACA;EACE,aAAa;EACb;AACF;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf;AACF;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB;AACF;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB;AACF;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd;AACF;AACA;EACE,eAAe;EACf,eAAe;EACf;AACF;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,qBAAqB;EACrB;AACF;AACA;EACE,iBAAiB;EACjB;AACF;AACA;EACE,YAAY;EACZ;AACF;AACA;EACE,YAAY;EACZ;AACF;AACA;EACE,cAAc;EACd,cAAc;EACd;AACF;AACA;EACE;AACF;AACA;EACE;AACF;AACA;EACE;IACE;EACF;EACA;IACE;EACF;EACA;IACE;EACF;EACA;IACE,SAAS;IACT,kBAAkB;IAClB;EACF;EACA;IACE;EACF;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB;EACF;EACA;IACE;EACF;EACA;IACE,kBAAkB;IAClB;EACF;EACA;IACE,kBAAkB;IAClB,UAAU;IACV;EACF;EACA;IACE;EACF;EACA;IACE;EACF;EACA;IACE,+BAA+B;IAC/B;EACF;EACA;IACE;EACF;EACA;IACE;EACF;EACA;IACE;EACF;EACA;IACE;EACF;EACA;IACE;EACF;EACA;IACE,SAAO;IACP;EACF;EACA;IACE;EACF;EACA;IACE;EACF;AACF;AACA,kFAAkF;AAClF;EACE;AACF;AACA;EACE;IACE;EACF;EACA;IACE;EACF;AACF;;AAEA,yDAAyD,uBAAuB,EAAE;AAClF,mBAAmB,cAAc,EAAE;AACnC,6BAA6B,YAAY,EAAE;AAC3C,mBAAmB,aAAa,EAAE,WAAW,EAAE;AAC/C,cAAc,aAAa,EAAE,2DAA2D,EAAE,WAAW,EAAE,gBAAgB,EAAE;AACzH,yBAAyB,qBAAqB,EAAE;AAChD,qBAAqB,yBAAyB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,aAAa,EAAE;AACzG,kCAAkC,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AAC1F,4BAA4B,gBAAgB,EAAE;AAC9C,+BAA+B,gBAAgB,EAAE,UAAU,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACtH,+BAA+B,iBAAiB,EAAE,6BAA6B,EAAE,uBAAuB,EAAE;AAC1G,sCAAsC,cAAc,EAAE,cAAc,EAAE,kBAAkB,EAAE;AAC1F,oCAAoC,eAAe,EAAE,iBAAiB,EAAE,cAAc,EAAE;AACxF,gCAAgC,qBAAqB,EAAE,uBAAuB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,eAAe,EAAE,iBAAiB,EAAE,cAAc,EAAE;AAC1K;EACE,cAAc,0CAA0C,EAAE;EAC1D,sBAAsB,cAAc,EAAE;EACtC,yBAAyB,cAAc,EAAE,eAAe,EAAE,kBAAkB,EAAE;AAChF;AACA,6BAA6B,cAAc,EAAE,gBAAgB,EAAE;AAC/D,gCAAgC,gBAAgB,EAAE;AAClD,4BAA4B,6BAA6B,gBAAgB,EAAE,EAAE;;AAE7E,mBAAmB,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACvE,yBAAyB,aAAa,EAAE,gDAAgD,EAAE,SAAS,EAAE;AACrG,wBAAwB,aAAa,EAAE,sBAAsB,EAAE,uBAAuB,EAAE,SAAS,EAAE,aAAa,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE,YAAY,EAAE;AACpQ,6CAA6C,qBAAqB,EAAE,mBAAmB,EAAE;AACzF,+BAA+B,eAAe,EAAE;AAChD,0CAA0C,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,uBAAuB,EAAE;AACtH,iCAAiC,WAAW,EAAE,eAAe,EAAE;AAC/D,YAAY,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,6BAA6B,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AAC/J,eAAe,eAAe,EAAE,eAAe,EAAE;AACjD,yBAAyB,cAAc,EAAE;AACzC,sCAAsC,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACzF;EACE,yBAAyB,qCAAqC,EAAE;EAChE,wBAAwB,aAAa,EAAE;EACvC,YAAY,sBAAsB,EAAE,uBAAuB,EAAE;EAC7D,gBAAgB,eAAe,EAAE;AACnC;;AAEA,iDAAiD,cAAc,EAAE","sourcesContent":[".data-connection {\n  width: 100%;\n  min-width: 0;\n  color: #14213b;\n  font-family: Manrope,\"Segoe UI\",sans-serif\n}\n.data-connection__header {\n  box-shadow: none\n}\n.dc-workspace {\n  background: #f8fafd;\n  border: 1px solid #e5eaf2;\n  border-radius: 14px;\n  padding: 26px;\n  min-height: 420px\n}\n.dc-workspace *,.dc-modal * {\n  box-sizing: border-box\n}\n.dc-tools {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px\n}\n.dc-search {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n  min-width: 220px;\n  margin: 0;\n  background: white;\n  border: 1px solid #e5eaf2;\n  border-radius: 11px;\n  padding: 0 14px;\n  color: #68758b\n}\n.dc-search input {\n  margin: 0;\n  border: 0;\n  outline: 0;\n  min-height: 48px;\n  min-width: 0;\n  width: 100%;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  color: #14213b\n}\n.dc-button,.dc-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 9px;\n  min-height: 44px;\n  border: 1px solid #dfe7f2;\n  border-radius: 10px;\n  background: white;\n  color: #334766;\n  padding: 10px 15px;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 650;\n  cursor: pointer;\n  text-decoration: none\n}\n.dc-tools > .dc-button {\n  min-height: 50px;\n  margin: 0\n}\n.dc-button--primary {\n  background: #1769e8;\n  color: white;\n  border-color: #1769e8\n}\n.dc-button--danger {\n  background: #b42332;\n  color: white;\n  border-color: #b42332\n}\n.dc-button:hover,.dc-icon:hover {\n  filter: brightness(.96)\n}\n.dc-button:disabled,.dc-icon:disabled {\n  opacity: .5;\n  cursor: default\n}\n.dc-icon {\n  width: 44px;\n  padding: 10px;\n  flex-shrink: 0\n}\n.data-connection button:focus-visible,.dc-modal button:focus-visible,.dc-modal input:focus-visible,.dc-modal select:focus-visible,.dc-modal textarea:focus-visible,.dc-search:focus-within {\n  outline: 3px solid #80b1ff;\n  outline-offset: 2px\n}\n.dc-filters {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin: 16px 0\n}\n.dc-filters select {\n  background: white;\n  border: 1px solid #e5eaf2;\n  border-radius: 9px;\n  min-height: 42px;\n  padding: 8px 12px;\n  font: inherit;\n  font-size: 13px;\n  color: #334766\n}\n.dc-filters>span {\n  margin-left: auto;\n  color: #68758b;\n  font-size: 12px\n}\n.dc-note {\n  font-size: 12px;\n  line-height: 1.6;\n  color: #68758b;\n  margin: 8px 0\n}\n.dc-list {\n  display: grid;\n  gap: 12px\n}\n.dc-card {\n  display: flex;\n  align-items: center;\n  border: 1px solid #dce6f5;\n  border-radius: 14px;\n  background: white;\n  min-width: 0;\n  padding-right: 12px;\n  transition: border-color .15s,background .15s\n}\n.dc-card:hover {\n  border-color: #9ebfee;\n  background: #fbfdff\n}\n.dc-card-main {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  width: 100%;\n  min-width: 0;\n  text-align: left;\n  padding: 20px;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  font: inherit;\n  color: inherit\n}\n.dc-source-icon {\n  display: grid;\n  place-items: center;\n  width: 50px;\n  height: 50px;\n  flex-shrink: 0;\n  border-radius: 14px;\n  background: #eaf2ff;\n  color: #1769e8;\n  font-size: 22px\n}\n.dc-source-icon--green {\n  background: #e9f8f2;\n  color: #159b70\n}\n.dc-card-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  min-width: 0;\n  flex: 1\n}\n.dc-card-copy>strong {\n  font-size: 16px;\n  line-height: 1.4;\n  overflow-wrap: anywhere\n}\n.dc-card-copy>span:not(.dc-badges) {\n  font-size: 13px;\n  color: #68758b;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%\n}\n.dc-badges {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap\n}\n.dc-badges em {\n  background: #eef4ff;\n  color: #3674c6;\n  border-radius: 20px;\n  padding: 4px 9px;\n  font-size: 11px;\n  font-style: normal\n}\n.dc-card-meta {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  gap: 10px;\n  width: 180px;\n  flex-shrink: 0\n}\n.dc-card-meta small {\n  font-size: 11px;\n  color: #68758b;\n  line-height: 1.5\n}\n.dc-pill {\n  background: #e8f7f0;\n  color: #168560;\n  padding: 5px 11px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600\n}\n.dc-pill--paused {\n  background: #fff4df;\n  color: #90621a\n}\n.dc-delete {\n  color: #8a6870;\n  border-color: transparent;\n  background: transparent\n}\n.dc-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 48px 20px;\n  background: white;\n  border: 1px dashed #d8e3f2;\n  border-radius: 14px;\n  gap: 12px\n}\n.dc-empty h2 {\n  font-size: 21px;\n  margin: 8px 0\n}\n.dc-empty p {\n  font-size: 14px;\n  line-height: 1.6;\n  color: #68758b;\n  max-width: 480px\n}\n.dc-alert {\n  background: #eaf7ef;\n  border: 1px solid #cbe8d6;\n  border-radius: 10px;\n  padding: 13px 16px;\n  margin: 12px 0;\n  font-size: 13px;\n  overflow-wrap: anywhere\n}\n.dc-alert--error {\n  background: #fff3f1;\n  border-color: #f0d1cc;\n  color: #962c22\n}\n.dc-status {\n  display: flex;\n  gap: 10px;\n  flex-direction: column;\n  font-size: 12px;\n  color: #68758b;\n  margin: 14px 0\n}\n.dc-status--error {\n  color: #a83d2f\n}\n.dc-status span {\n  overflow-wrap: anywhere;\n  max-width: 100%\n}\n.dc-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 2400;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: #16233b66;\n  backdrop-filter: blur(3px)\n}\n.dc-modal {\n  background: white;\n  border: 1px solid #dfe7f2;\n  border-radius: 18px;\n  width: min(820px,100%);\n  max-height: calc(100dvh - 48px);\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 24px 80px #14213b33;\n  color: #14213b;\n  font-family: Manrope,\"Segoe UI\",sans-serif;\n  overflow: hidden\n}\n.dc-modal>header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 24px;\n  border-bottom: 1px solid #e5eaf2;\n  flex-shrink: 0;\n  gap: 16px\n}\n.dc-modal h2 {\n  font-size: 20px;\n  margin: 0;\n  font-weight: 750\n}\n.dc-editor {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden\n}\n.dc-modal-body {\n  padding: 24px;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  min-height: 0\n}\n.dc-modal footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 16px 24px;\n  border-top: 1px solid #e5eaf2;\n  flex-shrink: 0;\n  background: white\n}\n.dc-modal fieldset {\n  border: 1px solid #e5eaf2;\n  border-radius: 12px;\n  margin: 16px 0;\n  padding: 16px;\n  min-width: 0\n}\n.dc-modal legend {\n  font-size: 14px;\n  font-weight: 750;\n  color: #334766;\n  padding: 0 6px\n}\n.dc-modal label {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  font-size: 13px;\n  color: #334766;\n  margin: 10px 0;\n  min-width: 0\n}\n.dc-modal input:not([type=checkbox]),.dc-modal select,.dc-modal textarea {\n  width: 100%;\n  min-width: 0;\n  border: 1px solid #dce5f1;\n  border-radius: 9px;\n  background: #fbfcff;\n  color: #14213b;\n  padding: 11px 12px;\n  font: inherit;\n  font-size: 14px;\n  min-height: 44px\n}\n.dc-modal textarea {\n  resize: vertical;\n  font-family: ui-monospace,monospace;\n  line-height: 1.5\n}\n.dc-two {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px\n}\n.dc-types {\n  display: flex;\n  gap: 10px\n}\n.dc-types button {\n  flex: 1;\n  min-height: 48px;\n  border: 1px solid #e5eaf2;\n  background: white;\n  color: #68758b;\n  border-radius: 11px;\n  font: inherit;\n  font-size: 14px;\n  cursor: pointer\n}\n.dc-types .selected {\n  border-color: #1769e8;\n  background: #edf4ff;\n  color: #1769e8\n}\n.dc-check {\n  display: flex!important;\n  flex-direction: row!important;\n  align-items: center;\n  gap: 12px!important;\n  line-height: 1.6\n}\n.dc-check input {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  accent-color: #1769e8\n}\n.dc-preview {\n  padding: 12px 0;\n  font-size: 13px;\n  overflow-wrap: anywhere\n}\n.dc-preview pre {\n  max-height: 280px;\n  overflow: auto;\n  border: 1px solid #e5eaf2;\n  border-radius: 10px;\n  background: #f6f9fd;\n  padding: 14px;\n  font: 12px/1.6 ui-monospace,monospace;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere\n}\n.dc-entities {\n  max-height: 300px;\n  overflow: auto\n}\n.dc-entities label {\n  padding: 8px;\n  border-bottom: 1px solid #edf0f5\n}\n.dc-entities span {\n  min-width: 0;\n  overflow-wrap: anywhere\n}\n.dc-entities small {\n  display: block;\n  color: #68758b;\n  font-size: 11px\n}\n.dc-entities label>span:last-child {\n  margin-left: auto\n}\n.dc-modal input:disabled {\n  opacity: .65\n}\n@media(max-width:760px) {\n  .dc-workspace {\n    padding: 16px 12px\n  }\n  .dc-search {\n    flex-basis: 100%\n  }\n  .dc-tools>.dc-button--primary {\n    flex: 1\n  }\n  .dc-card-main {\n    gap: 12px;\n    padding: 16px 12px;\n    flex-wrap: wrap\n  }\n  .dc-card-copy {\n    flex-basis: calc(100% - 65px)\n  }\n  .dc-card-meta {\n    width: 100%;\n    padding-left: 62px;\n    flex-direction: row;\n    align-items: center\n  }\n  .dc-card-main>svg {\n    display: none\n  }\n  .dc-card {\n    position: relative;\n    padding-right: 0\n  }\n  .dc-delete {\n    position: absolute;\n    right: 8px;\n    bottom: 10px\n  }\n  .dc-card-meta small {\n    padding-right: 35px\n  }\n  .dc-overlay {\n    padding: 10px\n  }\n  .dc-modal {\n    max-height: calc(100dvh - 20px);\n    border-radius: 14px\n  }\n  .dc-modal>header,.dc-modal footer {\n    padding: 13px 16px\n  }\n  .dc-modal-body {\n    padding: 16px\n  }\n  .dc-modal h2 {\n    font-size: 18px\n  }\n  .dc-modal fieldset {\n    padding: 12px\n  }\n  .dc-two {\n    grid-template-columns: 1fr\n  }\n  .dc-modal footer>.dc-button {\n    flex: 1;\n    padding: 10px 8px\n  }\n  .dc-filters>span {\n    margin-left: 0\n  }\n  .dc-empty {\n    padding: 32px 16px\n  }\n}\n/* Match the catalog's readable content scale; the shared header keeps its size. */\n.dc-workspace,.dc-overlay {\n  zoom: calc(1 / var(--dataspace-ui-scale,1))\n}\n@media(max-width:760px) {\n  .dc-modal input:not([type=checkbox]),.dc-modal select,.dc-modal textarea {\n    font-size: 16px\n  }\n  .dc-search input {\n    font-size: 16px\n  }\n}\n\n.dc-import-card .dc-card-copy small, .dc-import-target { overflow-wrap: anywhere; }\n.dc-import-error { color: #a52b30; }\n.dc-import-editor fieldset { min-width: 0; }\n.dc-counter-list { display: grid; gap: .75rem; }\n.dc-counter { display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1.7fr) auto; gap: .65rem; align-items: end; }\n.dc-counter > .dc-icon { margin-bottom: .55rem; }\n.dc-import-preview { border: 1px solid #dce6f5; background: #f7faff; border-radius: 12px; padding: 1rem; }\n.dc-import-preview > .dc-button { max-width: 100%; white-space: normal; text-align: left; }\n.dc-import-preview-result { margin-top: 1rem; }\n.dc-import-preview-result ul { list-style: none; padding: 0; margin: .75rem 0 0; max-height: 22rem; overflow-y: auto; }\n.dc-import-preview-result li { padding: .75rem 0; border-top: 1px solid #dce6f5; overflow-wrap: anywhere; }\n.dc-import-preview-result li > span { display: block; color: #61718a; margin-top: .25rem; }\n.dc-import-preview-result summary { cursor: pointer; margin-top: .6rem; color: #1766db; }\n.dc-import-preview-result pre { white-space: pre-wrap; overflow-wrap: anywhere; background: #fff; border-radius: 8px; padding: .75rem; max-height: 16rem; overflow: auto; }\n@media (max-width: 600px) {\n  .dc-counter { grid-template-columns: minmax(0, 1fr) auto; }\n  .dc-counter > label { grid-column: 1; }\n  .dc-counter > .dc-icon { grid-column: 2; grid-row: 1 / 3; align-self: center; }\n}\n.dc-import-card > .dc-icon { flex-shrink: 0; margin: 0 .75rem; }\n.dc-import-card .dc-card-meta { max-width: 18rem; }\n@media (max-width: 600px) { .dc-import-card > .dc-icon { margin: 0 .35rem; } }\n\n.dc-choice-intro { margin: 0 0 20px; color: #68758b; line-height: 1.6; }\n.dc-connection-choices { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 14px; }\n.dc-connection-choice { display: flex; flex-direction: column; align-items: flex-start; gap: 12px; padding: 20px; border: 1px solid #dce6f5; border-radius: 14px; background: #fff; text-align: left; font: inherit; color: #14213b; cursor: pointer; min-width: 0; }\n.dc-connection-choice:hover:not(:disabled) { border-color: #80b1ff; background: #f7faff; }\n.dc-connection-choice strong { font-size: 16px; }\n.dc-connection-choice > span:last-child { font-size: 13px; line-height: 1.6; color: #68758b; overflow-wrap: anywhere; }\n.dc-connection-choice:disabled { opacity: .5; cursor: default; }\n.dc-setup { display: flex; align-items: center; justify-content: space-between; gap: 20px; border-top: 1px solid #dce6f5; margin-top: 24px; padding-top: 20px; }\n.dc-setup h3 { margin: 0 0 8px; font-size: 16px; }\n.dc-setup > .dc-button { flex-shrink: 0; }\n.dc-import-card .dc-card-copy small { font-size: 12px; line-height: 1.5; color: #68758b; }\n@media (max-width: 600px) {\n  .dc-connection-choices { grid-template-columns: minmax(0, 1fr); }\n  .dc-connection-choice { padding: 16px; }\n  .dc-setup { flex-direction: column; align-items: flex-start; }\n  .dc-card-meta { flex-wrap: wrap; }\n}\n\n.dc-import-card .dc-card-copy .dc-import-error { color: #a52b30; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
